module.exports = __webpack_public_path__ + "media/images/gallery/main_on-5f3d7f5013ddb7e98389c660b4abb9d2.gif";